import { PLAN_REF_ID_MAPPING } from "@/data/plans";
import { TPlan } from "../types.checkout";

export function getBundlePlans(plans: TPlan[]): TPlan | undefined {
  if (!plans) return undefined;
  return plans.find((plan) => plan.productRefId == PLAN_REF_ID_MAPPING.all);
}

export function getIndividualPlans(plans: TPlan[]): TPlan[] {
  if (!plans) return [];
  return plans.filter((plan) => plan.productRefId !== PLAN_REF_ID_MAPPING.all);
}
